import { selectFieldsProgressAreas } from 'app/containers/Map/slice/selectors';
import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTaskSlice } from '../../slice';
import {
  selectAvailableThisStageUsedTaskResources,
  selectTaskProgressState,
  selectTaskResourcesState,
} from '../../slice/selectors';
import { ITaskAvailableResource, ITaskUsedResource } from '../../slice/types';
import AddTaskResourceForm from '../AddTaskResourceForm/AddTaskResourceForm';
import TaskResourcesTable from '../TaskResourcesTable/TaskResourcesTable';

interface IProps {}

const TaskThisStageUsedResourcesTable: FC<IProps> = props => {
  const dispatch = useDispatch();

  const { actions } = useTaskSlice();

  const { task } = useSelector(selectTaskProgressState);
  const availableUsedResources = useSelector(
    selectAvailableThisStageUsedTaskResources,
  );
  const { thisStageUsedResourcesArr } = useSelector(selectTaskResourcesState);

  const { totalProgressArea } = useSelector(selectFieldsProgressAreas);

  const onDeleteClick = (resource: ITaskUsedResource) => {
    dispatch(actions.toggleTaskThisStageUsedResource(resource));
  };

  const onNormChange = (resourceId: number, norm: number) => {
    dispatch(
      actions.updateTaskThisStageUsedResourceNorm({
        resourceId,
        norm,
      }),
    );
  };

  const onFormSubmit = (resource: ITaskAvailableResource, norm: number) => {
    if (resource) {
      const payload = {
        resourceId: resource.id,
        name: resource.name,
        cultureName: resource.cultureVariation?.culture.name,
        cultureId: resource.cultureVariation?.culture.id,
        norm,
        recommendedNorm: resource.recommendedNorm,
        unit: resource.type.unit,
      };

      dispatch(actions.toggleTaskThisStageUsedResource(payload));
    }
  };

  return (
    <>
      <TaskResourcesTable
        loading={false}
        isEditable={true}
        taskCategoryName={task?.category.name}
        area={totalProgressArea}
        resourcesArr={thisStageUsedResourcesArr}
        onDeleteClick={onDeleteClick}
        onNormChange={onNormChange}
      />
      <AddTaskResourceForm
        onFormSubmit={onFormSubmit}
        availableResources={availableUsedResources}
      />
    </>
  );
};

export default TaskThisStageUsedResourcesTable;
